<template>
  <ion-page id="animate-book-page">
    <ion-content>
      <div id="the_board" :style="styleBoard">
        <CMChessboard :fen="fen" :validMoves="availableMoves"   
                  :orientation="orientation" 
                  :flagBadMove=true
                  :animateOnePly="animateFen" :hint="hintFen"
                  :arrows="arrowPairs"
                  :setSquareColor="squareColorArray"
                  :boardSize="boardSize" @board-move="boardMove" />
      </div>

      <div id="the_statusline"
                  :style="styleStatusLine"
                  :class="{ 'text-dark' : isDark, 'text-light' : !isDark }"
                  @click="handleTextClick">
        <div v-html="pageText"></div>
      </div>

      <!-- <div id="the_slider" :style="styleSlider"  :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <ion-range aria-label="Range with ticks" :ticks="true"    
                    :snaps="true" v-model="wordNumberValue"
                    :min="0" :max="wordNumberCount" :step="1"
                    @ionChange="wordNumberChange">
          </ion-range>
      </div> -->
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                          @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup>

import { setInterval, setTimeout, clearInterval, clearTimeout } from 'requestanimationframe-timer';

  import { IonIcon,IonPage, IonContent, modalController, IonRange } from '@ionic/vue';
  import Toolbar from '@/components/Toolbar.vue';

  import CMChessboard from '@/components/CMChessboard.vue'

  import { ref, watch , nextTick } from 'vue'

  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  // imports from web version

  import { buildPieceLocationStrings, getPieceSetName, columnToNumber, squarePairToAlgebraic,
    buildAvailableMoves } from '@/composables/blindfoldSupport.js'
  import MoveHistory from '@/components/MoveHistory.vue'
  
  import { Chess } from '@/ts/chess.ts'

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'

  import { useGetData, getWebSiteURL } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { onMounted, onBeforeUnmount } from 'vue'

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } 
              from '@/composables/screenSize'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import { getListofVoices , voiceAddMicrophoneSupport } from '@/composables/voicesSupport.js'
  
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const MOVEHISTORY_FONTSIZE = 16
  const SLIDER_HEIGHT = 0 // 40

  const connectionStore = useConnectionStore()

  var isSubscriber = (connectionStore.getIsSubscriber == 1)

  const isDark = ref(connectionStore.getDarkmode != "light")
  const isMe = connectionStore.getIsMe

  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const showTour = ref(false)
  const showThumb = ref("none")

  const pageText = ref("")
  const oldTextString = ref("")
  const currentTextString = ref("")
  const futureTextString = ref("")

  const squareColorArray = ref([])
  var arrowPairs = ref([])

   // speaking

  var voices = []
  var engineVoiceNumber = -1
  var playerVoiceNumber = -1

  var timerMilliSeconds = 0
  let timerIncrement = 100

  var timerCanStop = false

  const TOOLBAR_PLAY = 0
  const TOOLBAR_BACK = 1
  const TOOLBAR_NEXT = 2
  const TOOLBAR_BRANCH = 3

  const toolbarElements = ref([
    { index : TOOLBAR_PLAY, label : "Play" , disabled : false, collapse:false},
    { index : TOOLBAR_BACK, label : "Back" , disabled : true, collapse:false},
    { index : TOOLBAR_NEXT, label : "Next" , disabled : true, collapse:false},
    { index : TOOLBAR_BRANCH, label : "Branches" , disabled : true, collapse:false},

  ])

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  const boardSize = ref(100)

  const fen = ref(INITIAL_FEN)
  const initialFenid4 = "147869767"
  const hintFen = ref([])
  const animateFen = ref([]) 

  var blankAppendTrigger = " "
  var orientation = ref("white")
  const availableMoves = ref([])

  const wordNumberValue = ref(0)
  const wordNumberCount = ref(0)

  const toolbarTrigger = ref(0)

  var chess = new Chess()

  var currentFen = INITIAL_FEN
  var returnToAfterHintfen = INITIAL_FEN

  var optionDisplayArray = []
  var optionDisplaySelected = ""
  var optionHeading = ""

  var pageStack = []
  var paragraphs = []
  var branches = []
  var words = []
  var wordTimes = []

  var currentPage = (isMe) ?   { page : "henry" , label : "Henry's Testing Page" , paragraph : 0} :
                  { page : "welcome" , label : "Welcome to the Audio Book" , paragraph : 0 }

  var mp3 = null
  var texts = null
  var actions = null
  var words = null
  var saveFens = null

  var lastActionTime = 0
  var timerIsPaused = true
  var audioIsPlaying = false

  // need to track if button or slider caused the pause or it is paused because it hit the end
  var audioDuration = 0

  var audio = null
  var timerId = null
  var pageChanged = false
  var actionTimeMap = new Map()
  var textTimeMap = new Map()
  var wordTimeMap = new Map()
  var saveFenMap = new Map()

  var textWindowHeight = 0
  var textWindowTop = 0

  var firstWordHighlightIndex = 0
  var lastWordHighlightIndex = 0

  let styleDim = (isDark.value) ? "'color: grey;'" : "'color: gray;'"
  let styleHighlight = (isDark.value) ? "'color: white;'" : "'color: black;'"
  let styleUl = "'padding-bottom : 0px;padding-top : 5px;;margin-top : 0px; margin-bottom : 0px;'"
  let styleLi = "'padding-left : 20px;padding : 0px;;margin-top : 0px; margin-bottom : 0px;'"
  let styleP = "'padding-top : 5px;padding-bottom : 0px;;margin-top : 0px; margin-bottom : 0px;'"
  let styleBr = "'padding-top : 10px;padding-bottom : 0px;;margin-top : 0px; margin-bottom : 0px;'"
  let styleH3 = "'padding-top : 0px; padding-bottom : 5px;margin-top : 0px; margin-bottom : 0px;'"
  let styleH4 = "'padding-top : 0px; padding-bottom : 5px;;margin-top : 0px; margin-bottom : 0px;'"
  let styleH5 = "'padding-top : 0px; padding-bottom : 5px;;margin-top : 0px; margin-bottom : 0px;'"
  let styleB = "'font-weight: bold;'"
  let styleI = "'font-style: italic;'"

  // tour stuff

  const sliceDiceTourInfo = {
    id : "opening_slicedice",
    elements : [
      { id: "", title: "Explore", text : "Why are we deciding our opening moves based on how the game ends 40 to 60 moves later?<br><br>That's an unfair burden for the game's first few moves."},
      { id: "", title: "There Is A Better Way!", text : "Chess Opening Mastery is a game changing, data driven approach to evaluating the game's first moves.<br><br>"},
      { id: "", title: "A Window into the Middle Game", text : "Chess Opening Mastery's revolutionary approach shows how the games are progressing in the middle game.<br><br>How? For every game, the Stockfish computer engine has been used to evaluate the position before white's moves 12, 15, 18 and 21. Stockfish scores each board as having an advantage for white (positive numbers) or an advantage for black (negative numbers)." },
      { id: "", title: "Stockfish Scores", text : "You probably know that a pawn is worth 1 point, a bishop/knight is worth 3 and a rook is 5 points. Stockfish reports back a position as being the equivalent of 'up' some number of pawns.<br><br>The bar chart shows that distribution for games start with the given move sequence."},
      { id: "", title: "The Game Collection", text : "The Lichess 'rapid' games were used to build the tree. With a unique twist - only games where the players are within the same 50 point 'bucket' are included.<br><br>Why? Because even a 50 point difference between two players gives the higher rated player a 6% win advantage which swamps any advantage that can be obtained by a particular opening."},
      { id: "the_tree", title: "The Graph", text : "The graph shows the distribution of the Stockfish engine scores for games where the checked move(s) was made.<br><br>For example, if '1.e4' is checked and the slider is at move 15 then the graph shows how well players who played 'e4' are doing in their games at move 15."},
      { id: "the_tree", title: "The Bars", text : "The bars show the percentage of games in each bucket. The buckets start on the left with black having already won the game by the future move number. Next to that is the percentage of games where black has a 'huge' advantage"},
      { id: "the_tree", title: "The Point Bars", text : "The next several bars break the stockfish engine scores into one point buckets.<br><br><i>(The 3 point bucket represents being up a bishop and the 1 point bucket represents being up by a pawn.)</i>"},
      { id: "the_tree", title: "The Middle &amp; White's Bars", text : "The center bar shows the percentage of games that are about even.<br><br>The bars to the right are white's mirroring the black buckets from 1 point through already won games."},
      { id: "the_toolbar", title: "Options", text : "Used to set the rating range and color."},
    ]
  }

  const tourInfo = ref(sliceDiceTourInfo)

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleStatusLine = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    padding : "4px",
    margin : "0px",
    "line-height" : "1.2em",
    "text-align" : "left"
  })

  const styleMoveHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em",
    // "background-color" : "#8198bc",
    // "color" : "white"
  })

  const styleSlider = ref({
    position : "absolute",
    "overflow-y" : "hidden",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "padding-left" : "10px",
    "padding-right" : "10px",

    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    //console.log("in after start" ,stuffChanged,errorProgram,errorEntry)
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    isSubscriber = (connectionStore.getIsSubscriber == 1)

    getListofVoices(handleVoicesCallback)

    menuTrigger.value++
    updateWidthHeights()

    console.log("is me ",isMe,isSubscriber)
    if (!isMe ) {
      const initialPageStack = connectionStore.getAudioBookPageStack
      //console.log("INITIAL PAGE STACK ",initialPageStack)

      // if not a subscriber, limit them to two levels, the welcome and intro theory pages
      if (isSubscriber == true || initialPageStack.length == 0) {
        pageStack = initialPageStack.pages
        if (initialPageStack.current != null)
          currentPage = initialPageStack.current
        else
          currentPage = { page : "welcome" , label : "Welcome to the Audio Book" , paragraph : 0 }
      }
    }
    else 
      currentPage = { page : "henry" , label : "Henry's Testing Page" , paragraph : 0}
                  
    getAudioPage(currentPage.page)
  }
  
  function handleVoicesCallback(voices1,playerNumber,engineNumber) {
    //console.log("VOICE NUMBERS",playerNumber,engineNumber)
    playerVoiceNumber = playerNumber
    engineVoiceNumber = engineNumber
    voices = voices1

      // load audio book instructions
    //saySomething(false)
  }

  onMounted(() => {
    updateWidthHeights()
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
    menuTrigger.value++
  })

  // START SPEAKING SUPPORT

  function whenDoneSpeakingCallback(condition) {
    //console.log("Speaking done ",condition,bookIndex)
    if (bookIndex < bookOperations.length )
      saySomething(false)
  }

  // END SPEAKING SUPPORT

  function handleTextClick(e) {
    let clickedElId = e.target.id
    console.log("click",e)
    console.log(clickedElId)

    if (clickedElId.length >= 5 && clickedElId.substring(0,4) == "word") {
      const wordNumber = parseInt(clickedElId.substring(4))
      wordNumberValue.value = wordNumber
      wordNumberChange()
    }
  }
  function scrollToSpan() {
    var firstSpan = document.getElementById('word' + firstWordHighlightIndex);
    var lastSpan = document.getElementById('word' + lastWordHighlightIndex);

    //console.log("Scroll to span elements",firstSpan,lastSpan)

    if (firstSpan == null && lastSpan == null)
      return

    if (firstSpan == null)
      firstSpan = lastSpan
    if (lastSpan == null)
      lastSpan = firstSpan
    const firstRect = firstSpan.getBoundingClientRect();
    const lastRect = lastSpan.getBoundingClientRect();

    const useBottom = (firstRect.bottom >  lastRect.top) ? firstRect.bottom : lastRect.top
    //console.log("high",firstRect.top,firstRect.bottom)
    //console.log("after",lastRect.top,lastRect.bottom)
    //console.log("useBottom",useBottom)

    if (useBottom > textWindowTop + textWindowHeight) 
      firstSpan.scrollIntoView()
    else
      if (firstRect.bottom < textWindowTop)
        firstSpan.scrollIntoView()

    //targetSpan.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
    //targetSpan.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function surroundHtmlCodes(word,styleColor,wordIndex) {
    
    const spanWithStyle = "<span id='word" + wordIndex + "' style=" + styleColor + ">"
    const spanEnd = "</span>"

    var htmlBefore = ""
    var htmlAfter = ""
    var text = spanWithStyle
    var state = "begin"
    for (var j=0; j < word.length; j++) {
      switch (state) {
        case "begin" :
          if (word[j] == "<") {
            state = "beforeHtml"
            htmlBefore += word[j]
          }
          else {
            state = "text"

            if (isMe && wordIndex == 0)
              text +=  "*** Henry *** "
            text += word[j]
          }
          break
        case "beforeHtml" :
          htmlBefore += word[j]
          if (word[j] == ">")
            state = "begin"
          break
        case "text" :   
          if (word[j] == "<") {
            htmlAfter += word[j]
            state = "afterHtml"
          }
          else
            text += word[j]
          break
        case "afterHtml" :
          htmlAfter += word[j]
          break
      } 
    }

    text += spanEnd

    //console.log("word bits ",htmlBefore,htmlAfter,text)

    const newWord =  htmlBefore + text + htmlAfter
   
    //console.log("New Word", newWord)
    return (newWord)
  }

  function forceFenColor(fen,color) {
    var fenParts = fen.split(" ")
    fenParts[1] = color
    const newFen = fenParts.join(" ")
    return (newFen)
  }

  function buildPageText(firstHighlight,lastHighlight) {
    
    firstWordHighlightIndex = firstHighlight
    lastWordHighlightIndex = lastHighlight

    const spanHighlightWithId = "<span id='high' style=" + styleHighlight + ">"
    const spanHighlight = "<span style=" + styleHighlight + ">"
    const spanAfterWithId = "<span id='after' style=" + styleDim + ">" 
    const spanDim = "<span style=" + styleDim + ">" 
    const spanEnd = "</span>"

    var hasBefore = false
    var hasHighlight = false
    var hasAfter = false

    const beforeArray = []
    const highlightArray = []
    const afterArray = []
    
    //console.log("first and last - build page text",firstHighlight,lastHighlight)

    for (var i=0; i < words.length; i++) {
      var word = words[i].word

      if (i < firstHighlight) {
        word = surroundHtmlCodes(word,styleDim,i)
        beforeArray.push(word)
        hasBefore = true
      }
      else
      if (i > lastHighlight) {
        word = surroundHtmlCodes(word,styleDim,i)
        afterArray.push(word)
        hasAfter = true
      }
      else {
        word = surroundHtmlCodes(word,styleHighlight,i)
        highlightArray.push(word)
        hasHighlight = true
      }
    }
    
    const beforeString = beforeArray.join(" ")
    const afterString = afterArray.join(" ")
    const highlightString = highlightArray.join(" ")

    //console.log("highlightString.length",highlightString.length)
    var bigTextString = ""

    // if nothing highlighted, put a dummy one at first position
    // this will force scroll to beginning
    // if (hasHighlight == false)
    //   bigTextString += spanHighlightWithId + spanEnd

    if (hasBefore)
      bigTextString += beforeString + " "

    if (hasHighlight)
      bigTextString += highlightString + " "

    // always push the after to get the id="after"
    bigTextString += afterString

    pageText.value = bigTextString
    //console.log(bigTextString)

    // Wait for the DOM to update after v-html renders
    nextTick(() => {
      // The element rendered by v-html is now available in the DOM
      scrollToSpan()
    })
      
  }

  function findActions(updateBoard) {
    var timeHasActionWithText = false

    const oneWord = wordTimeMap.get(timerMilliSeconds)
    const oneText = textTimeMap.get(timerMilliSeconds)
    const oneAction = actionTimeMap.get(timerMilliSeconds)

    // word is on this time so update the slider
    if (updateBoard && oneWord != null) {
      wordNumberValue.value = oneWord.index
    }

    if (updateBoard && oneText != null)
      buildPageText(oneText.first,oneText.last)

    if (oneAction == null)
      return;

    //console.log("time hit",timerMilliSeconds)

    var actionCount = actions.length
    for (var i=0; i < actionCount; i++) {
      const oneAction = actions[i]
      if (oneAction.time != timerMilliSeconds)
        continue;

      //console.log("Action",oneAction.action,oneAction.time,oneAction.target)

      switch (actions[i].action) {
        case "color-remove" :
          squareColorArray.value = []
          break
        case "arrow-remove" :
          arrowPairs.value = []
          break          
        case "hint-remove" :
          //console.log("HINT REMOVE",currentFen)
          if (updateBoard)
            animateFen.value = [currentFen , returnToAfterHintfen]
          currentFen = returnToAfterHintfen
          break
        case "arrow" :
          arrowPairs.value = []
          const arrows = oneAction.target.split(",")
          for (var j=0; j < arrows.length; j++) {
            var oneArrow = arrows[j]
            const fromToColor = oneArrow.split("-")
            if (fromToColor.length < 3)
              oneArrow += "-blue"
            arrowPairs.value.push(oneArrow)
          }
          //console.log("Arrows ",arrowPairs.value)
          break;
  
        case "move" :
          try {
            chess.load(currentFen.trim())
          } catch (e) {
            console.error(e)
          }
          try {
            chess.move(oneAction.target)
          } catch (e) {
            console.error(e)
          }
          const nextFen = chess.fen()
          //console.log("Next Fen ",nextFen,oneAction.target)
          if (updateBoard)
            animateFen.value = [currentFen , nextFen]
          currentFen = nextFen    
          break
        case "usefen" : // slot number from the savefen
          const fenSlotNumber = parseInt(oneAction.target)
          var fenToUse = saveFenMap.get(fenSlotNumber)
          //console.log("slot fen",fenSlotNumber,fenToUse)
          if (fenToUse == null)
            fenToUse = INITIAL_FEN
          currentFen = fenToUse
          //console.log("usefen. ",fenSlotNumber,fenToUse)
          try {
            chess.load(currentFen.trim())
          } catch (e) {
            console.error(e)
          }
          incrementAppendTrigger()
          if (updateBoard)
            fen.value = fenToUse + blankAppendTrigger
          break
        case "hint-white" :
        case "hint-black" :
          //console.log("HINT go back to ",currentFen)
          returnToAfterHintfen = currentFen
          // let it fall through to the white and black
        case "white" :
        case "black" :
          //console.log("Action",oneAction.action,oneAction.time,oneAction.target)

          const forceColor = (actions[i].action == "white" || actions[i].action == "hint-white")? 'w' : 'b'
          currentFen = forceFenColor(currentFen,forceColor)
          
          try {
            chess.load(currentFen.trim())
          } catch (e) {
            console.error(e)
          }
          
          //chess.setTurn((actions[i].action == "white" || actions[i].action == "hint-white")? 'w' : 'b')

          try {
            chess.move(oneAction.target)
          } catch (e) {
            console.error(e)
          }
          const nextFenForColor = chess.fen()
          //console.log("Next Fen ",nextFen,oneAction.target)
          if (updateBoard)
            animateFen.value = [currentFen , nextFenForColor]
          currentFen = nextFenForColor    
          break
        // case "fen" :
        //   incrementAppendTrigger()
        //   if (updateBoard)
        //     fen.value = oneAction.target + blankAppendTrigger
        //   currentFen = oneAction.target + blankAppendTrigger
        //   //console.log("FEN ",fen.value)
        //   try {
        //     chess.load(currentFen.trim())
        //   } catch (e) {
        //     console.error(e)
        //   }
        //   break
        case "color" :
          squareColorArray.value = []
          const squares = oneAction.target.split(",")
          for (var j=0; j < squares.length; j++) {
            var oneSquare = squares[j]
            const colorParts = oneSquare.split("-")

            const squarePart = colorParts[0]
            const colorPart = (colorParts.length <= 1) ? "blue_frame" : colorParts[1]
            squareColorArray.value.push({ square : squarePart , color : colorPart})
          }
          break
      }
    }
  }

  /*
  const id_1 = setTimeout((a) => console.log(a), 1000, '1000 ms timeout');
const id_2 = setInterval((a) => console.log(a), 2000, '2000 ms interval');
setTimeout(() => {
  clearTimeout(id_1);
  clearInterval(id_2);
}, 10000);
*/

  //.  https://github.com/kambing86/requestanimationframe-timer
  
  function startTimer() {
    timerIsPaused = false

    function oneInterval() {
      if (timerMilliSeconds > lastActionTime + 1000) {
        console.log("timer is done")
        clearInterval(timerId)
        timerId = null
        return
      }
      if (timerIsPaused == false) {
        findActions(true)
        //console.log("Timer in milliseconds", timerMilliSeconds)
        timerMilliSeconds += timerIncrement
      }
    }
    timerId = setInterval(oneInterval, timerIncrement)
  }
  

  function boardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {

    console.log("board move",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)

  }

  function formatDate(date,separator) {
    const year = date.toLocaleString('default', {year: 'numeric'});
    const month = date.toLocaleString('default', {
      month: '2-digit',
    });
    const day = date.toLocaleString('default', {day: '2-digit'});

    return [year, month, day].join(separator);
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleStatusLine.value.height = boundaries['status'].height + "px"
    styleStatusLine.value.width = boundaries['status'].width + "px"
    styleStatusLine.value.top = boundaries['status'].top + "px"
    styleStatusLine.value.left = boundaries['status'].left + "px"

    textWindowHeight = boundaries['status'].height
    textWindowTop = boundaries['status'].top

    styleSlider.value.height = boundaries['slider'].height + "px"
    styleSlider.value.width = boundaries['slider'].width + "px"
    styleSlider.value.top = boundaries['slider'].top + "px"
    styleSlider.value.left = boundaries['slider'].left + "px"
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    //console.log("updatewidth in repdrill ",availableSpace,isPortrait)

    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    const availableSpaceForBoard = { width : availableSpace.width ,
                  height : availableSpace.height / 2,
                  isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = boardPositionTop + boardHeight
    const statusPositionLeft = availableSpace.leftRightIndent
    const statusHeight = availableSpace.height - statusPositionTop - SLIDER_HEIGHT
    const statusWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const sliderPositionTop = statusPositionTop + statusHeight
    const sliderPositionLeft = availableSpace.leftRightIndent
    const sliderHeight = SLIDER_HEIGHT
    const sliderWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      },
      slider : {
        width : sliderWidth,
        height : sliderHeight,
        left : sliderPositionLeft + availableSpace.leftIndent,
        top : sliderPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    const availableSpaceForBoard = { width : availableSpace.width / 2,
                height : availableSpace.height ,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = 0
    const statusPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const statusHeight = availableSpace.height - SLIDER_HEIGHT
    const statusWidth = availableSpace.width - statusPositionLeft

    const sliderPositionTop = statusPositionTop + statusHeight
    const sliderPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const sliderHeight = SLIDER_HEIGHT
    const sliderWidth = availableSpace.width - sliderPositionLeft

    const result = { 
      board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      },
      slider : {
        width : sliderWidth,
        height : sliderHeight,
        left : sliderPositionLeft + availableSpace.leftIndent,
        top : sliderPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  // End for Slice & Dice

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function tourDone() {
    showTour.value = false
  }

  function buildBranchList() {
    optionDisplayArray = []

    // if isMe, then put that first so I can access a test page
    // if (isMe) {
    //   const oneItem = { 
    //     index : optionDisplayArray.length,
    //     name : "'henry.page' for testing",
    //     id : "henry",
    //     radio : "" + "henry"
    //   }
    //   optionDisplayArray.push(oneItem)
    // }

    // put parent first
    //console.log("PageStack",pageStack)
    if (pageStack.length > 0) {
      const parentBranch = pageStack[pageStack.length-1]
      const oneItem = { 
        index : optionDisplayArray.length,
        name : parentBranch.label + "  (parent)",
        id : "PARENT",
        radio : "" + "PARENT"
      }
      optionDisplayArray.push(oneItem)
    }
    for (var i=0; i < branches.length; i++) {
      const oneItem = { 
        index : optionDisplayArray.length,
        name : branches[i].label,
        id : branches[i].page,
        radio : "" + branches[i].page
      }
      optionDisplayArray.push(oneItem)
    }
    // if (isMe)
    //   optionDisplaySelected = "henry"
    // else
      optionDisplaySelected = "" + (branches.length > 0) ? branches[0].page : "PARENT"
    optionHeading = "Where to Go Next"

    openGenericSingleListModal()
  }

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // did user leave the select the same?
      // if (data.selected == optionDisplaySelected)
      //   return

      //console.log("CONFIRM in static",data)
      // if (data.selected == "henry") {
      //   console.log("push henry current page",currentPage)
      //   pageStack.push(currentPage)
      //   const henryPage = { page: "henry", label : "henry.page for testing"}
      //   currentPage = henryPage
      //   stopAudioTimer()
      //   getAudioPage("henry")
      // }
      // else
      if (data.selected == "PARENT") {
        currentPage = pageStack.pop()

        if (!isMe)
          connectionStore.setAudioBookPageStack(pageStack,currentPage)

        stopAudioTimer()
        getAudioPage(currentPage.page)
      }
      else {
        for (var i=0; i < branches.length; i++)
          if (branches[i].page == data.selected) {
            pageStack.push(currentPage)
            currentPage = branches[i]

            if (!isMe)
              connectionStore.setAudioBookPageStack(pageStack,currentPage)

            stopAudioTimer()
            getAudioPage(data.selected)
            break
          }
      }
   }
  };

  // END Generic Options List

  function stopAudioTimer() {
    // pageChanged = true
    // timerMilliSeconds = 10000000000
    // if (audio != null)
    //   audio.pause()
  }

  function wordNumberChange() {

    buildPageText(wordNumberValue.value,wordNumberValue.value)

    setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   
    toolbarTrigger.value++

    const oneWord = words[wordNumberValue.value]
    console.log("one word",oneWord)
    audio.currentTime = oneWord.time / 1000.0
    audio.pause()
    console.log("current time in slider",audio.currentTime,oneWord.time)

    // get all the actions up to this point
    currentFen = INITIAL_FEN
    squareColorArray.value = []
    arrowPairs.value = []
    for (timerMilliSeconds = 0; timerMilliSeconds <= oneWord.time; timerMilliSeconds += timerIncrement)
      findActions(false)
    chess.load(currentFen)
    incrementAppendTrigger()
    fen.value = currentFen + blankAppendTrigger
  }

  function toolbarClick(index) {

    const element = findToolbarElement(toolbarElements.value,index)
    if (element.disabled)
      return

    switch (index) {
      case TOOLBAR_PLAY :
        if (audioIsPlaying) {
          timerIsPaused = true
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   
          audio.pause()
        }
        else {
          timerIsPaused = false
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Pause")   
          audio.play()
        }
        toolbarTrigger.value++
        break    
      case TOOLBAR_BACK :
        if (currentPage.paragraph == 0)
          return

        // clean out anything going on with the current page
        if (timerId != null) {
          clearInterval(timerId)
          timerId = null
        }
        audio.pause()

        currentPage.paragraph--

        if (!isMe)
          connectionStore.setAudioBookPageStack(pageStack,currentPage)

        if (currentPage.paragraph == 0)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        loadParagraph()
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,false)
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   
        toolbarTrigger.value++
        break
      case TOOLBAR_NEXT :
        if (currentPage.paragraph >= paragraphs.length - 1)
          break

        // clean out anything going on with the current page
        if (timerId != null) {
          clearInterval(timerId)
          timerId = null
        }
        audio.pause()

        currentPage.paragraph++

        if (!isMe)
          connectionStore.setAudioBookPageStack(pageStack,currentPage)

        if (currentPage.paragraph == paragraphs.length - 1)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,true)
        loadParagraph()
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,false)
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   
        toolbarTrigger.value++
        break
      case TOOLBAR_BRANCH :
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   
        toolbarTrigger.value++
        audio.pause()
        timerIsPaused = true

        // if only thing is parent, do that
        if (branches.length == 0 && pageStack.length > 0) {
          currentPage = pageStack.pop()

          if (!isMe)
            connectionStore.setAudioBookPageStack(pageStack,currentPage)

          stopAudioTimer()
          getAudioPage(currentPage.page)
          break
        }
        //console.log("branch clicked")
        buildBranchList()
        break
    }
  }

  function audioStartedPlaying(event) {
    
    console.log("timerID",timerId,audio.currentTime)
    if (audio.currentTime == 0) {
      fen.value = INITIAL_FEN
      currentFen = INITIAL_FEN
      squareColorArray.value = []
      arrowPairs.value = []
      timerMilliSeconds = 0;
      buildPageText(100000000,0)
    }
    if (timerId == null)
      startTimer()
    else
      timerIsPaused = false
    audioIsPlaying = true
    console.log("audio started")
  }

  function audioPaused(event) {
    console.log("in paused",audio.currentTime,audioDuration)

    // don't pause the timer, let it run out

    audioIsPlaying = false

    // if the currentTime is near the duration then treat it as the ended call
    if (Math.abs(audio.currentTime - audioDuration) < .2) {
      buildPageText(0,100000000)

      // reset the audio to play again from the beginning
      audio.currentTime = 0;
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   
      toolbarTrigger.value++
      //console.log("here in pause as ended")
    }
    else {
      timerIsPaused = true
      audioIsPlaying = false
      //console.log("audio paused")
    }
  }

  function audioEnded(event) {


  }
  
  function audioLoadData() {
    console.log("****** Audio Load Data");
  }


  function audioLoadMetadata() {
    // Now the duration property is available
    audioDuration = audio.duration;
    console.log("****** Audio duration:", audioDuration, "seconds");
  }

  function loadParagraph() {

    timerMilliSeconds = 0
    squareColorArray.value = []
    arrowPairs.value = []

    fen.value = INITIAL_FEN
    currentFen = INITIAL_FEN

    const paragraph = paragraphs[currentPage.paragraph]
    mp3 = paragraph.mp3

    texts = paragraph.texts
    actions = paragraph.actions
    words = paragraph.words
    saveFens = paragraph.saveFens

    actionTimeMap.clear()
    textTimeMap.clear()
    wordTimeMap.clear()
    saveFenMap.clear()

    //console.log("saveFens array",saveFens)
    // slot zero is always the initial board
    saveFenMap.set(0,INITIAL_FEN)
    for (var i=0; i < saveFens.length; i++)
      saveFenMap.set(saveFens[i].slot,saveFens[i].fen)

    //console.log("SaveFENmap",saveFenMap)
    for (var i=0; i < words.length; i++) {
      const oneWord = words[i]
      wordTimeMap.set(oneWord.time,oneWord)
    }

    // flag all the time periods with actions.
    for (var i=0; i < actions.length; i++) {
      const oneAction = actions[i]

      //console.log("initial setup",oneAction.action,oneAction.time)
      actionTimeMap.set(oneAction.time,oneAction)

    }
 
    for (var i=0; i < texts.length; i++) {
      const oneText = texts[i]

      //console.log("initial text time ",oneText.time)
      textTimeMap.set(oneText.time,oneText)
    }
    //console.log("action map",actionTimeMap)
    //console.log("text map",textTimeMap)
    //console.log("word map",wordTimeMap)

    lastActionTime = words[words.length - 1].time + 1000
    //console.log("LAST ACTION TIME ",lastActionTime)

    wordNumberValue.value = 0
    wordNumberCount.value = words.length - 1

    buildPageText(1000000,0)

    const webURL = getWebSiteURL()

    const location = webURL + "/spoken/" + mp3
    audio = new Audio(location);
    //console.log("AUDIO",audio)
    pageChanged = false
    audio.onplaying = audioStartedPlaying
    audio.onpause = audioPaused
    audio.onended = audioEnded
    audio.onloadedmetadata = audioLoadMetadata
    audio.onloadeddata = audioLoadData
  }

  function processAudioPageJsonResponse(json) {
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    // parent pages
    branches = []
    paragraphs = [] 
    var branchCount = 0
  
    //console.log("use branches ",isSubscriber,pageStack.length)
    // if not a subscriber, ignore the branches if already at the 2nd level
    if (isSubscriber == true || pageStack.length == 0) {
      branchCount = json['branch_count']
      const branchPages = json['branch_pages'].split("\t")
      const branchLabels = json['branch_labels'].split("\t")
      for (var i=0; i < branchCount; i++) {
        const oneBranch = { index : i,
              page : branchPages[i],
              label : branchLabels[i],
              paragraph : 0
        }
        branches.push(oneBranch)
      }
    }

    const mp3s = json['mp3'].split("\t")
    const paragraphCount = json['count']

    //console.log("mp3s",mp3s)
    //console.log("paragraph count",paragraphCount)

    for (var i = 0; i < paragraphCount; i++) {
      var word_array = []
      var text_array = []
      var action_array = []
      var saveFen_array = []
      
      const wordCount = json['word_count' +i ]
      const actionCount = json['action_count' + i]
      const textCount = json['text_count' + i]

      // get the word list as one chunk to do the html replacement then split
      var allWords = json['word' + i]
      const wordTimesArray = json['word_time' + i].split("\t")

      // put the styles inline because v-html makes it more complicated with CSS
      allWords = allWords.replaceAll("<ul>","<ul style=" + styleUl + ">")
      allWords = allWords.replaceAll("<li>","<li style=" + styleLi + ">")
      allWords = allWords.replaceAll("<br>","<br style=" + styleBr + ">")
      allWords = allWords.replaceAll("<p>","<p style=" + styleP + ">")
      allWords = allWords.replaceAll("<b>","<b style=" + styleB + ">")
      allWords = allWords.replaceAll("<i>","<i style=" + styleI + ">")
      allWords = allWords.replaceAll("<h3>","<h3 style=" + styleH3 + ">")
      allWords = allWords.replaceAll("<h4>","<h4 style=" + styleH4 + ">")
      allWords = allWords.replaceAll("<h5>","<h5 style=" + styleH5 + ">")
    
      const words = allWords.split("\t")
  
      for (var j=0; j < wordCount; j++) {
        const oneWord = {
            index : j,
            word : words[j],
            time : parseInt(wordTimesArray[j])
        }
        word_array.push(oneWord)
      }

      // the text actions are separate
      const textFirst = json['text_first' + i].split("\t")
      const textLast = json['text_last' + i].split("\t")
      for (var j=0; j < textCount; j++) {
        const firstWord = parseInt(textFirst[j])
        const oneText = {
            time : word_array[firstWord].time,
            first : firstWord,
            last : parseInt(textLast[j])
        }
        text_array.push(oneText)
      }

      const actions = json['action' + i].split("\t")
      const wordIndexs = json['word_index' + i].split("\t")
      const targets = json['target' + i].split("\t")

      const moveDelayAdjust = 0
      for (var j=0; j < actionCount; j++) {
        const wordNumber = parseInt(wordIndexs[j])

        // grab the "savefen" entries and don't turn them into actions
        if (actions[j] == "savefen") {
          const oneSaveFen = {
            slot : wordNumber,
            fen : targets[j]
          }
          saveFen_array.push(oneSaveFen)
          continue;
        }

        const one_action = {
            action : actions[j],
            wordIndex : wordNumber,
            time : (word_array[wordNumber].time >=  moveDelayAdjust) ? 
                                  word_array[wordNumber].time - moveDelayAdjust :  word_array[wordNumber].time,
            target : targets[j].replaceAll(";",",")
        }
        action_array.push(one_action)
      }
    
      const one_paragraph = {
        mp3: mp3s[i],
        words : word_array,
        actions : action_array,
        texts : text_array,
        saveFens : saveFen_array
      }
      paragraphs.push(one_paragraph)
    }
    
    //console.log("paragraphs",paragraphs)

    setToolbarElementLabel(toolbarElements.value,TOOLBAR_PLAY,"Play")   

    const branchButtonLabel = (branchCount == 0 && pageStack.length > 0) ? "Parent" : "Branches"
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_BRANCH,branchButtonLabel)   
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BRANCH,branchCount == 0 && pageStack.length == 0)

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)

    if (paragraphs.length > 1)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,false)
    else
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT,true)
    toolbarTrigger.value++

    //currentPage.paragraph = 0
    loadParagraph()
  }

  function getAudioPage(pageName) {
    //console.log("*** get page")
    var formData = {
      page : pageName,
      version : "v2"
    }
    //console.log("formData",formData)
    useGetData("get4_audio_opening.php", formData, processAudioPageJsonResponse)
  }

</script>

<style scoped>

/* ion-content {
    --background: lightgray;
    --color: #fff;
    --overflow: hidden;
  } */

ion-button[slot='fixed'] {
    top: 0%;
    left : 0%;
    height : 5%;
    width : 100%;
  }

.blue {
  position :absolute;
  background-color: blue;
  top : 0px;
  left : 0px;
  height : 100px;
  width : 200px;
  z-index : -1;
}

.green {
  position :absolute;
  background-color: green;
  top : 200px;
  left : 50px;
  height : 100px;
  width : 200px;
}

</style>

